import React, { useState, useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
//Prime
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { useLanguage } from "../../../Language/LanguageContext";
import Drone_Status_Regulator from "../../../Style_Component/Steps/User_Drone_Status";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import Static_modal from "../../user/etc/Static_modal";

export default function AffiliatedPilot(prop) {
  const { t, changeLanguage, language, fontFamily } = useLanguage()
  const [globalFilter, setGlobalFilter] = useState(null);
  const [pilotDataList, setPilotDataList] = useState([]);
  const [loading, setLoading] = useState(true);



  //modal config
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };

  //mui config
  const renderHeaderPilot = () => {
    return (
      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
        <Button 
            className="m-0"
            variant="success"
            onClick={() => {
              setSearchPilot(true);
              // findPilot();
            }}
          >
            <h4 style={{ margin: "0" }}>{t('pilotstatus.addpilot')}</h4>
          </Button>
        <IconField iconPosition="left">
          <InputText
            style={{ width: "auto" }}
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            placeholder="🔍  ค้นหา..."
          />
        </IconField>
      </div>
    );
  };
  const headerPilot = renderHeaderPilot();
  function filtered_Pilot(data) {
    console.log(data);
    const filteredData = data.filter(
      (item) =>
        item.pilot_name
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.pilot_type
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.status_text
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join(""))

    );
    return filteredData;
  }

  //mui body table
  function Body_pilot_name(data) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ textAlign: "left" }}>

          {data.pilot_name}
        </div>
      </div>
    );
  }
  function Body_pilot_status(data) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{
          textAlign: "left", color: (() => {
            switch (data.status_text) {
              case "เข้าร่วม":
                return "#008000";

              case "ไม่เข้าร่วม":
                return "#FF0000";
              default:
                return "#FF8C00";
            }
          })(),
        }}>

          {data.status_text ?? "ติดต่อเจ้าหน้าที่"}
        </div>
      </div>
    );
  }
  function Body_pilot_type(data) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{
          textAlign: "left", color: (() => {
            switch (data.pilot_type) {
              case "OPEN":
                return "#008000";
              case "SPECIFIC":
                return "#FF8C00";
              default:
                return "#FF0000";
            }
          })(),
        }}>

          {data.pilot_type}
        </div>
      </div>
    );
  }
  function Body_cancle_pilot(data) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>

          <div
            onClick={() => {
              console.log("Test");
              setDeletingSelect([
                data.pilot_id,
                data.co_id,
                data.pilot_name,
              ]);
              setShowDeletePilot(true);
            }}
            className="custom-btn btnCancel"
            style={{ fontSize: "16px" }}
          >
            X
          </div>
        </div>
      </div>
    );
  }

  const RenderLoading = () => {
    return (
      <>
        <h2 className="profile-header">นักบินในสังกัด</h2>
        <div className="user-main">
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            {" "}
            <Spinner animation="border" variant="secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      </>
    )
  }

  //API 
  const getpilot = async () => {
    AuthServiceV2.PilotlistforO()
      .then((res) => {
        console.log(res);
        if (res.data.status === "error") {
          handleClose_Modal()
          setTextBody("เกิดข้อผิดพลาด 200");
          setModalToggle({ ...modalToggle, modalErr: true });
        } else {
          console.log(res.data.pilot_data);
          setPilotDataList(res.data.pilot_data);

        }
      })
      .catch((error) => {
        handleClose_Modal(error)
        setTextBody("เกิดข้อผิดพลาด 200");
        setModalToggle({ ...modalToggle, modalErr: true });
      });
  };
  const [deletingSelect, setDeletingSelect] = useState([]);
  const [showDeletePilot, setShowDeletePilot] = useState(false);
  const deletePilot = (pilot_id, co_id) => {
    const deletePilot = AuthServiceV2.OperemovePilot(pilot_id, co_id);
    if (deletePilot != null) {
      deletePilot
        .then((res) => {
          handleClose_Modal()
          setModalToggle({ ...modalToggle, modalSuccess: true });
          setTimeout(() => {
            setLoading(true)
          }, 1000);
       
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const [idpilot, setIdpilot] = useState("");
  const [codepilot, setCodepilot] = useState("");
  const [pilotdata, setPilotdata] = useState("");
  const findPilot = () => {
    const check = AuthServiceV2.FindpilotforO(idpilot, codepilot);
    if (check != null) {
      check
        .then((res) => {
          if (res === "Invalid pilot code") {
            handleClose_Modal()
            setTextBody("กรุณากรอกข้อมูลให้ถูกต้อง");
            setModalToggle({ ...modalToggle, modalErr: true });
          } else if (
            res === "The pilot id field must be an integer. (and 1 more error)"
          ) {
            handleClose_Modal()
            setTextBody("กรุณากรอกข้อมูลให้ถูกต้อง");
            setModalToggle({ ...modalToggle, modalErr: true });
          } else if (res === "The pilot id field must be an integer.") {
            handleClose_Modal()
            setTextBody("กรุณากรอกข้อมูลให้ถูกต้อง");
            setModalToggle({ ...modalToggle, modalErr: true });
          } else if (
            res === "The pilot id field is required. (and 1 more error)"
          ) {
            handleClose_Modal()
            setTextBody("กรุณากรอกข้อมูลให้ถูกต้อง");
            setModalToggle({ ...modalToggle, modalErr: true });
          } else if (res === "The pilot code field is required.") {
            handleClose_Modal()
            setTextBody("กรุณากรอกข้อมูลให้ถูกต้อง");
            setModalToggle({ ...modalToggle, modalErr: true });
          } else if (res === "The pilot id field is required.") {
            handleClose_Modal()
            setTextBody("กรุณากรอกข้อมูลให้ถูกต้อง");
            setModalToggle({ ...modalToggle, modalErr: true });
          } else {
            setPilotdata(res.data.pilot_data);
            console.log(res.data);
          }
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  const [addsuc, setAddsuc] = useState(false);
  const [searchPilot, setSearchPilot] = useState(false);
  const addpilot = () => {
    const check = AuthServiceV2.AddpilotforO(idpilot, codepilot);
    if (check != null) {
      check
        .then((res) => {
          handleClose_Modal()
          setModalToggle({ ...modalToggle, modalSuccess: true });
          setTimeout(() => {
            setLoading(true)
          }, 1000);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });

          if (error.response) {
            // The request was made and the server responded with a status code
            handleClose_Modal()
            setTextBody(error.response.data.error_description);
            setModalToggle({ ...modalToggle, modalErr: true });
          } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an error
            console.log("Error", error.message);
          }
        });
    }
  };

  useEffect(() => {
    handleClose_Modal()
    const fetchData = async () => {
      await getpilot();


    };
    setTimeout(() => {
      fetchData()
      setLoading(false)
    }, 500);

  }, [loading]);
  return (
    <>
      {loading ? <RenderLoading /> :
        <>
          <h2 className="profile-header">นักบินในสังกัด</h2>
          <div className="user-main">

            <DataTable
              value={globalFilter ? filtered_Pilot(pilotDataList) : pilotDataList}
              paginator
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              rows={5}
              rowsPerPageOptions={[5, 10]}
              header={headerPilot}
              emptyMessage="ไม่มีข้อมูล"
              tableStyle={{ minWidth: "50rem" }}
              style={{ fontFamily: "Kanit" }}
            >


              <Column
                header={t('pilotstatus.name')}
                body={Body_pilot_name}
                field="pilot_name"
                sortable
                filterField="pilot_name"
                bodyStyle={{ textAlign: "center" }}
                style={{ width: "15%" }}
              ></Column>
              <Column
                header={t('pilotstatus.type')}
                body={Body_pilot_type}
                field={`pilot_type`}
                sortable
                filterField="pilot_type"
                bodyStyle={{ textAlign: "center" }}
                style={{ width: "15%" }}
              ></Column>
              <Column
                header={t('pilotstatus.status')}
                body={Body_pilot_status}
                field={`status_text`}
                sortable
                filterField="status_text"
                bodyStyle={{ textAlign: "center" }}
                style={{ width: "20%" }}
              ></Column>

              <Column
                header={t('pilotstatus.canclepilot')}
                body={Body_cancle_pilot}
                bodyStyle={{ textAlign: "center" }}
                style={{ width: "20%" }}
              ></Column>
            </DataTable>
          </div>
          <Static_modal
            modalwaiting={modalToggle.modalwait}
            modalErr={modalToggle.modalErr}
            modalSuccess={modalToggle.modalSuccess}
            modalDenied={modalToggle.modalDenied}
            textBody={textBody}
            getHandle={handleClose_Modal}
          />
          <Modal
            show={showDeletePilot}
            onHide={() => {
              setDeletingSelect([]);
              setShowDeletePilot(false);
            }}
            className="font-cen"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>ยืนยันการลบนักบิน</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h4>คุณยืนยันที่จะลบนักบิน {deletingSelect[2]} หรือไม่</h4>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="custom-btn btnCancel"
                onClick={() => {
                  setDeletingSelect([]);
                  setShowDeletePilot(false);
                }}
              >
                ยกเลิก
              </Button>
              <Button
                className="custom-btn btnSave"
                onClick={() => {
                  deletePilot(deletingSelect[0], deletingSelect[1]);
                  setDeletingSelect([]);
                  setShowDeletePilot(false);
                }}
              >
                ยืนยัน
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            size="lg"
            show={searchPilot}
            onHide={() => {
              setSearchPilot(false);
              setIdpilot("");
              setCodepilot("");
            }}
            className="font-cen"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>ผลลัพธ์การค้นหา</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div
                style={{
                  width: "100%",
                  height: "auto",
                }}
              >
                <h4>หมายเลขนักบิน</h4>
                <input
                  style={{
                    border: "1px solid black",
                    width: "100%",
                    paddingLeft: "10px",
                    height: "35px",
                    fontSize: "20px",
                    borderRadius: "10px",
                  }}
                  onChange={(e) => setIdpilot(e.target.value)}
                ></input>
                <h4>Code นักบิน</h4>
                <input
                  style={{
                    border: "1px solid black",
                    width: "100%",
                    paddingLeft: "10px",
                    height: "35px",
                    fontSize: "20px",
                    borderRadius: "10px",
                  }}
                  onChange={(e) => setCodepilot(e.target.value)}
                ></input>

                <div
                  onClick={() => {
                    findPilot();
                  }}
                  style={{
                    display: "flex",
                    width: "20%",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#B5F1CC",
                    height: "50px",
                    cursor: "pointer",
                    borderRadius: "10px",
                    margin: "25px auto 0px auto",
                    border: "3px solid black",
                  }}
                >
                  <h4>ค้นหา</h4>
                </div>
                <div style={{ height: "25px" }}></div>
                {pilotdata != "" ? (
                  <Table striped bordered={false} hover>
                    <thead>
                      <tr
                        style={{ paddingTop: "20px", height: "80px" }}
                        key={pilotdata.pilot_name}
                      >
                        <th>ชื่อ</th>
                        <th>code นักบิน</th>
                        <th>ประเภทการบิน</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>{pilotdata.pilot_name}</td>
                        <td>
                          {pilotdata.pilot_code_specific ||
                            pilotdata.pilot_code_open}
                        </td>
                        <td>{pilotdata.pilot_type}</td>
                      </tr>
                    </tbody>
                  </Table>
                ) : null}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="custom-btn btnCancel"
                onClick={() => {
                  setSearchPilot(false);
                }}
              >
                ยกเลิก
              </Button>
              <Button
                className="custom-btn btnSave"
                onClick={() => {
                  addpilot();
                  setIdpilot("");
                  setCodepilot("");
                  setSearchPilot(false);
                }}
              >
                เพิ่มนักบิน
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            size="lg"
            show={addsuc}
            onHide={() => {
              setSearchPilot(false);
            }}
            className="font-cen"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>ผลลัพธ์การเพิ่มนักบิน</Modal.Title>
            </Modal.Header>
            <Modal.Body>เพิ่มนักบินเรียบร้อย</Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  setSearchPilot(false);
                }}
              >
                ปิด
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      }
    </>
  );
};


